import React from 'react';
import { List, Filter, Edit, Create, Datagrid, ReferenceField, LongTextInput, AutocompleteInput, TextField, NumberField, EditButton, DisabledInput, ReferenceInput, TabbedForm, FormTab, TextInput, ImageField, ImageInput, NumberInput } from 'admin-on-rest';

const MealsFilters = (props) => (
    <Filter {...props}>
        <TextInput label="Search" source="query" alwaysOn />
    </Filter>
);

export const MealsList = (props) => (
    <List {...props} filters={<MealsFilters />}>
        <Datagrid>
            <TextField source="name" />
            <NumberField source="nutritional_values.carbohydrates" label="Carbohydrates" />
            <NumberField source="nutritional_values.protein" label="Protein" />
            <NumberField source="nutritional_values.fat" label="Fat" />
            <TextField source="ingridients" />
            <TextField source="label" />
            <NumberField source="calories" />            
            <ReferenceField label="Meal Category" source="meal_category" reference="mealscategories">
                <TextField source="name"/>
            </ReferenceField> 
            <ImageField source="cover_image.url" label="Cover image" />
            <EditButton />
        </Datagrid>
    </List>
);

export const MealsEdit = (props) => (
    <Edit {...props}>
        <TabbedForm>
            <FormTab label="General">
                <DisabledInput source="id" />
                <TextInput source="name" />
                <LongTextInput source="ingridients" /> 
                <TextInput source="label" />
                <ReferenceInput label="Meal Category" source="meal_category" filterToQuery={searchText => ({ query: searchText })} reference="mealscategories">
                    <AutocompleteInput source="id" optionText="name" optionValue="id"/>
                </ReferenceInput>          
                <ImageInput source="cover_image" label="Cover image" accept="image/*">
                    <ImageField source="url" />
                </ImageInput>  
            </FormTab>
            <FormTab label="Nutritonal Values">
                <NumberInput source="nutritional_values.carbohydrates" label="Carbohydrates"/>
                <NumberInput source="nutritional_values.protein" label="Protein"/>
                <NumberInput source="nutritional_values.fat" label="Fat"/>
                <NumberInput source="calories" />                
            </FormTab>
        </TabbedForm>
    </Edit>
);

export const MealsCreate = (props) => (
    <Create {...props}>
        <TabbedForm>
            <FormTab label="General">
                <TextInput source="name" />
                <LongTextInput source="ingridients" /> 
                <TextInput source="label" />
                <ReferenceInput label="Meal Category" source="meal_category" reference="mealscategories" filterToQuery={searchText => ({ query: searchText })} allowEmpty={true}>
                    <AutocompleteInput source="id" optionText="name" optionValue="id"/>
                </ReferenceInput>          
                <ImageInput source="cover_image" label="Cover image" accept="image/*">
                    <ImageField source="url" />
                </ImageInput>  
            </FormTab>
            <FormTab label="Nutritonal Values">
                <NumberInput source="nutritional_values.carbohydrates" label="Carbohydrates"/>
                <NumberInput source="nutritional_values.protein" label="Protein"/>
                <NumberInput source="nutritional_values.fat" label="Fat"/>
                <NumberInput source="calories" />                
            </FormTab>
        </TabbedForm>
    </Create>
);


// WEBPACK FOOTER //
// ./src/resources/meals.js